import emailFinderSaga from "./email-finder.saga";
import emailValidationSaga from "./email-validation.saga";

export default [emailFinderSaga, emailValidationSaga];